import OurTrustingClient from './OurTrustingClient'

export default OurTrustingClient
